import { Injectable } from '@angular/core';
import { HierarchyFilterType } from '@app/features/hierarchy/models/hierarchy.constants';
import { NodeDto } from '@app/features/hierarchy/models/hierarchy.model';
import { EntitySelectionModel } from '@components/data/data-table-new/entitySelectionModel';

export type HierarchySelectionFilterData = [string, string, string, HierarchyFilterType?, string?] | [] | null;

@Injectable()
export class UserListOverlayFilterData {
  selection = new EntitySelectionModel<NodeDto>();
  hierarchySelectionFilterData: HierarchySelectionFilterData;
  hieValue = '';

  clear(): void {
    this.selection.clear();
    this.hieValue = '';
    this.hierarchySelectionFilterData = null;
  }
}
